import { DictionariesState } from './index';

export const initialState: DictionariesState = {} as any;
